import Vue from "vue";
import utils from "./utils";

const directives = {
  //按钮权限指令
  btnPermission: {
    inserted(el, binding) {
      setPermissions(el, binding);
    },
    bind(el, binding) {
      setPermissions(el, binding);
    },
    update(el, binding) {
      setPermissions(el, binding);
    },
  },
  "autocomplete-load": {
    bind(el, binding, vNode) {
      const select = el.querySelector('.el-autocomplete-suggestion__wrap');
      select.addEventListener('scroll', function () {
        console.log(this.scrollHeight - this.scrollTop,'this.scrollHeight - this.scrollTop');
        console.log(this.clientHeight,'this.clientHeight')
        const condition = Math.floor(this.scrollHeight - this.scrollTop) <= this.clientHeight;
        console.log(condition,'condition')
        if (condition) {
          binding.value();
        }
      })
      // let wrapDom = el.querySelector(".el-autocomplete-suggestion__wrap");
      // let listDom = el.querySelector(
      //   ".el-autocomplete-suggestion__wrap  .el-autocomplete-suggestion__list"
      // );
      // wrapDom.addEventListener(
      //   "scroll",
      //   (e) => {
      //     let condition =
      //       wrapDom.offsetHeight +
      //       wrapDom.scrollTop +
      //       20 -
      //       listDom.offsetHeight;
      //     if (condition > 0 && !vNode.context.loading) {
      //       //滚动到底部则执行滚动方法load，binding.value就是v-scrollLoad绑定的值，加()表示执行绑定的方法
      //       binding.value();
      //     }
      //   },
      //   false
      // );
    },
  },
};
export function setPermissions(el, binding) {
  let buttonKey = binding.value;
  // 代表某个元素需要通过权限验证
  if (buttonKey) {
    let key = utils.isAuth(buttonKey);
    if (!key) {
      //没有权限
      el.remove(); //删除按钮
      el.parentNode && el.parentNode.removeChild(el);
    }
  } else {
    throw new Error("缺少权限编码");
  }
}
export default directives;
